import { render, staticRenderFns } from "./StackedColumns.vue?vue&type=template&id=efaadb16&scoped=true&"
import script from "./StackedColumns.vue?vue&type=script&lang=js&"
export * from "./StackedColumns.vue?vue&type=script&lang=js&"
import style0 from "./StackedColumns.vue?vue&type=style&index=0&id=efaadb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaadb16",
  null
  
)

export default component.exports